export default class DataTable
{
	schema;
	data;
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataTable.js